export function isFunction(obj) {
  return typeof obj === 'function';
}